/**
 * Represents the action's status
 */
export const enum ActionStatus {
  Success = 'SUCCESS',
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING',
  Error = 'ERROR',
}
